import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, isAnalyticsEnabled, trackPageView } from '../lib/analytics';

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (!isAnalyticsEnabled()) {
      return;
    }

    initAnalytics();
  }, []);

  useEffect(() => {
    if (!isAnalyticsEnabled()) {
      return;
    }

    const pagePath = `${location.pathname}${location.search}${location.hash}`;
    trackPageView(pagePath);
  }, [location.pathname, location.search, location.hash]);

  return null;
};

export default AnalyticsTracker;
